import { Injectable } from '@angular/core';
import moment from 'moment';
import { Storage } from '@ionic/storage';
import { LocalStorage } from '../local-storage/local-storage';
import { ByDayCollection } from '../../models/collections.model';
import { AgendaJourActiviteInterne, AgendaJourOt, AgendaJourTempo } from '../../models/agenda/agenda-jour.model';

@Injectable({ providedIn: 'root' })
export class AgendaHelperService extends LocalStorage {
  /**
   * Délai en minutes avant de rappeler le webservice
   */
  public readonly AGENDA_REFRESH_DELAY = 10 * 60000;

  constructor(protected override storage: Storage) {
    super();
  }

  async setCollectionToLocal(
    resultCollection: ByDayCollection<AgendaJourOt | AgendaJourTempo | AgendaJourActiviteInterne>,
    agendaLocalKey: string,
    dateDebut?: moment.Moment,
    dateFin?: moment.Moment
  ) {
    await this.storage.set(agendaLocalKey, resultCollection);
    await this.setLastRequestDateToNow(agendaLocalKey);
  }
}
